import { CheckCircle } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  LinearProgress,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { amazonColors } from "../../../config/amazonTheme";

interface ProductRefreshStatusProps {
  isRefreshing: boolean;
  hasData?: boolean;
}

const ProductRefreshStatus: React.FC<ProductRefreshStatusProps> = ({
  isRefreshing,
  hasData = true,
}) => {
  const { t } = useTranslation();

  // Don't show status if we don't have data yet
  if (!hasData) {
    return null;
  }

  if (isRefreshing) {
    return (
      <Box
        sx={{
          p: 2,
          mb: 2,
          borderRadius: 2,
          backgroundColor: "#f5f5f5",
          border: `1px solid ${amazonColors.gray[200]}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 1.5,
          }}
        >
          <CircularProgress
            size={20}
            sx={{
              color: amazonColors.blue || "#1976d2",
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: amazonColors.text.primary,
              fontWeight: 500,
            }}
            className="notranslate"
            translate="no"
          >
            {t("products.checkingBestPrice")}
          </Typography>
        </Box>
        <LinearProgress
          sx={{
            height: 4,
            borderRadius: 2,
            backgroundColor: amazonColors.gray[200],
            "& .MuiLinearProgress-bar": {
              backgroundColor: amazonColors.blue || "#1976d2",
            },
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: 2,
        backgroundColor: "#e8f5e9",
        border: `1px solid #c8e6c9`,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <CheckCircle
        sx={{
          color: "#2e7d32",
          fontSize: 20,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          color: "#1b5e20",
          fontWeight: 500,
        }}
        className="notranslate"
        translate="no"
      >
        {t("products.productInfoUpToDate")}
      </Typography>
    </Box>
  );
};

export default ProductRefreshStatus;
